import template from './admin-hotel-settings.html';
import suppliers from './../../../supplier/suppliers';

const DIRECTIVE_NAME = AdminHotelSettings.DIRECTIVE_NAME = 'ktAdminHotelSettings';
export default function AdminHotelSettings() {
    return {
        restrict: 'A',
        controller: AdminHotelSettingsController,
        controllerAs: 'adminHotelSettingsCtrl',
        template,
        bindToController: true,
        scope: {
            hotel: `=${DIRECTIVE_NAME}`,
            editMode: `@${DIRECTIVE_NAME}EditMode`,
        },
        link: function($scope, $elem, $attrs, adminHotelSettingsCtrl) {
            adminHotelSettingsCtrl.$onInit();
        },
    };
}

export function AdminHotelSettingsController() {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        $onInit,
        doesHotelHaveAmadeusOrBookingComProvider,
    });

    function $onInit() {
    }

    function doesHotelHaveAmadeusOrBookingComProvider() {
        return vm.hotel.suppliers.includes(suppliers.amadeus.id)
            || vm.hotel.suppliers.includes(suppliers.bookingCom.id);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-view/admin-hotel-settings/admin-hotel-settings-component.js